/* eslint-disable camelcase */

import { GTMPushEvent } from "./../index";
import defaultParameters from "./default-parameters";

export const initialLoadGtmEvent = ({ search_id, pageType }) => {
  GTMPushEvent({
    ...defaultParameters(pageType),
    search_id,
    design_type: "new",
  });
};
